import { useFormContext } from "react-hook-form";
import RadioButtonGroup from "../../../gds/RadioButtonGroup";
import YesNoOptions from "../../../../constants/options/YesNoOptions";

/**
 * EoPolicyQuestions component handles the E&O (Errors & Omissions) policy related questions
 * including active policy status and intention to get coverage.
 * Only renders for users with the "principal" role.
 */
export default function EoPolicyQuestions() {
    const { watch, control } = useFormContext();

    // Watch form values
    const watchRole = watch("role");
    const watchEoPolicy = watch("activeEoPolicy");

    // Only render for principals
    if (watchRole !== "principal") {
        return null;
    }

    return (
        <div>
            <div className="flex-row">
                <RadioButtonGroup
                    control={control}
                    name="activeEoPolicy"
                    legend={<>
                        Do you have an active E&O policy?<span className="required">*</span>
                    </>}
                    layout="Two Column"
                    options={YesNoOptions}
                />
            </div>

            {watchEoPolicy === "false" &&
                <div className="flex-row">
                    <RadioButtonGroup
                        control={control}
                        name="intendEoPolicy"
                        legend={<>
                            Do you intend to get E&O coverage for this appointment?<span className="required">*</span>
                        </>}
                        layout="Two Column"
                        options={YesNoOptions}
                    />
                </div>
            }
        </div>
    );
}